const starndard = {
  canEnableFullscreen() {
    return document.fullscreenElement;
  },
  fullscreenIsOn(el) {
    // === null 则表示不在全屏中
    return (el || document).fullscreenElement !== null;
  },
  requestFullscreen(el) {
    if (!el || !el.requestFullscreen) return Promise.reject(Error('入参元素不支持全屏'));
    return el.requestFullscreen();
  },
  exitFullscreen() {
    return document.exitFullscreen();
  },
  onfullscreenchange() {},
  onfullscreenerror() {},
};

const google = {
  canEnableFullscreen() {
    return document.webkitFullscreenEnabled;
  },
  fullscreenIsOn(el) {
    // === null 则表示不在全屏中
    return (el || document).webkitFullscreenElement !== null;
  },
  requestFullscreen(el) {
    if (!el || !el.webkitRequestFullscreen) return Promise.reject(Error('入参元素不支持全屏'));
    return el.requestFullscreen();
  },
  exitFullscreen() {
    return document.webkitExitFullscreen();
  },
  onfullscreenchange() {},
  onfullscreenerror() {},
};

const firefox = {
  canEnableFullscreen() {
    return document.mozFullscreenEnabled;
  },
  fullscreenIsOn(el) {
    // === null 则表示不在全屏中
    return (el || document).mozFullscreenElement !== null;
  },
  requestFullscreen(el) {
    if (!el || !el.mozRequestFullscreen) return Promise.reject(Error('入参元素不支持全屏'));
    return el.requestFullscreen();
  },
  exitFullscreen() {
    return document.mozExitFullscreen();
  },
  onfullscreenchange() {},
  onfullscreenerror() {},
};

const IE = {
  canEnableFullscreen() {
    return document.msFullscreenEnabled;
  },
  fullscreenIsOn(el) {
    // === null 则表示不在全屏中
    return (el || document).msFullscreenElement !== null;
  },
  requestFullscreen(el) {
    if (!el || !el.msRequestFullscreen) return Promise.reject(Error('入参元素不支持全屏'));
    return el.requestFullscreen();
  },
  exitFullscreen() {
    return document.msExitFullscreen();
  },
  onfullscreenchange() {},
  onfullscreenerror() {},
};

function getFullscreen() {
  switch (true) {
    case Boolean(document.fullscreenElement):
      return starndard;
    case Boolean(document.webkitFullscreenElement):
      return google;
    case Boolean(document.mozFullScreenElement):
      return firefox;
    case Boolean(document.msFullScreenElement):
      return IE;
    default:
      return starndard;
  }
}

export default {
  ...getFullscreen(),
};
